export default __webpack_public_path__ + "static/media/instruction6.dccaed03.png";